




































import { snakeCase } from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import i18n from 'vue-i18n'
import { Prop } from 'vue-property-decorator'
import { DirectiveBinding } from 'vue/types/options'
import { VNode } from 'vue/types/umd'

import { SocketNames } from '../../components'
import { CustomConnection } from '../../logic/Connections/CustomConnection'
import CustomEditor from '../../logic/Editor/CustomEditor'
import { FlowStatisticsMode, FlowStatValueType } from '../../logic/Editor/types'
import FlowHelper from '../../logic/Helpers/helper'
import CustomInput from './CustomInput'
import FakeSocket from './FakeSocket.vue'
import Socket from './Socket.vue'

@Component({
  name: 'InputSocket',
  data() {
    return {
      snakeCase,
      FakeSocket,
      SocketNames
    }
  },
  components: {
    Socket
  },
  directives: {
    socket: {
      bind(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      },
      update(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      }
    },
  }
})
export default class InputSocket extends Vue {
  @Prop() input!: CustomInput

  @Prop() editor!: CustomEditor

  @Prop() bindSocket!: DirectiveBinding

  @Prop() i18n!: i18n

  get hiddenConnections(): Array<CustomConnection> {
    return this.input.connections
      .filter((c) => !c.data.visible)
  }

  get styles(): { [key: string]: string | number } {
    return {
      backgroundColor: `rgba(${ FlowHelper.typeSocketColor(this.input.name) }, 0.3)`,
    }
  }

  get inputValue() {
    const { statistics } = this.editor

    if (statistics) {
      const { statSetting } = statistics

      const count = this.input.node.inputConnectionsTotalValue()
      const trKey = `node_total_input_value_by_criteria_${ statSetting.mode }_${ statSetting.valueType }`
      const percent = statSetting.valueType === FlowStatValueType.Percent ? '%' : ''

      if (statSetting.mode === FlowStatisticsMode.User) {
        const rawUsername = statSetting.user.login
        let username: string | undefined = undefined

        if (rawUsername) {
          username = rawUsername.length > 13 ? `${ rawUsername.slice(0, 10) }...` : rawUsername
        }

        return `${ this.i18n.tc(trKey, count, { count, username, percent }) }`
      } else {
        return `${ this.i18n.tc(trKey, count, { count, percent }) }`
      }
    }

    return ''
  }

  destroyed(): void {
    /**
     * При изменении состояния видимости (удалении непосредственно выхода, либо просто сокрытии, как в случае с выходом бездействия)
     * автоматически обрубит все соединения с этим соккетом
     * */
    this.input.connections.forEach((c) => this.editor.removeConnection(c))
  }
}
